import React, { useState } from 'react';
import { Choose } from 'react-extras';
import UsernameVerified from '../IrctcLoginModals/userNameVerified/VerifiedIrctcUserName';
import UserNotVerified from '../IrctcLoginModals/userNameNotVerified';
import UsernameDeactivated from '../IrctcLoginModals/userNameDeactivated';
import ForgotUsername from '../IrctcLoginModals/forgotUserName/ForgotUserName';
import FailureWrongDetails from '../IrctcLoginModals/FailureWrongDetails';
import GetUsernameSuccess from '../IrctcLoginModals/userNameSuccess';
import ForgotPassword from '../IrctcLoginModals/forgotPassword';
import GetPasswordFailure from '../IrctcLoginModals/GetPasswordFailure';
import GetPasswordSuccess from '../IrctcLoginModals/GetPasswordSuccess';
import EmailAndMobileNotVerified from '../IrctcLoginModals/emailAndMobileNotVerified/emailMobileNotVerifeid';
import MobileNotVerified from '../IrctcLoginModals/emailAndMobileNotVerified/mobileNotVerified';
import EmailNotVerified from '../IrctcLoginModals/emailAndMobileNotVerified/emailNotVerified';
import UserProfileIncomplete from '../IrctcLoginModals/userProfileIncomplete';
import UserAccountSuspended from '../IrctcLoginModals/userAccountSuspended';
import ForgotPasswordStandalone from '../IrctcLoginModals/forgotPassword/ForgotPasswordStandalone';
import DefaultCase from '../IrctcLoginModals/defaultCase';
import GetPasswordFailureStandAlone from '../IrctcLoginModals/getPasswordFailure/GetPasswordFailureStandAlone';
import GetPasswordSuccessStandalone from '../IrctcLoginModals/getPasswordStandAlone';
import { VerifyIrctcUserName, VerifyIrctcUserNameNew} from '../IrctcLoginModals/verifyIrctcUsername';
import { useSelector } from 'react-redux';
import { irctcEducationPopup } from '../../../../constants/AbConfigKeys';

export interface UserFlowModalState {
  currentModal?: string,
  userStatus: {
    userId: string,
    mobileEntered?: string,
    nextPage?: string,
    error?: string,
    otpType?: string,
    email?: string,
  },
  allowClose: boolean,
  showModal: boolean,
  switchModal?: (currentModal?: any, userStatus?: any) => void,
  closeModal?: () => void,
  updateVerifiedUser?: (userId: string) => void,
  createAccount?: () => void,
  isStandAlone?: boolean,
  isEmailNotVerified?: boolean,
  isMobileNotVerified?: boolean,
  emailMobileNotVerified?: boolean,
}

export const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

export default function UserFlowModal(props: UserFlowModalState) {
  const [ state, setState ] = useState<Partial<UserFlowModalState>>({
    allowClose: props.allowClose,
    closeModal: props.closeModal,
    showModal: props.showModal,
  });
  const [currentModal, setCurrentModal] = useState(props.currentModal);
  const [ userId, setUserId ] = useState(props.userStatus.userId);
  const [userStatus, setUserStatus] = useState({
    userId: '',
    mobileEntered: '',
    nextPage: '',
    error: '',
    otpType: '',
    email: ''
  });

  /*set different user modals*/
  const switchModal = (currentModal, userStatus) => {
    setCurrentModal(currentModal);
    if(userStatus && userStatus.userId){
      setUserId(userStatus.userId);
      setUserStatus(userStatus);
    }
  };

  const { updateVerifiedUser, createAccount } = props;
  const { allowClose, closeModal } = state;
  const {
    abConfig: { [irctcEducationPopup]: isIRCTCEducation }
  } = useSelector((state: any) => state);
  return (
    <Choose>
      <Choose.When condition={currentModal === 'verifyUsername' && isIRCTCEducation===0}>
        <VerifyIrctcUserName
          userStatus={{ userId }}
          showModal={true}
          switchModal={switchModal}
          allowClose={allowClose}
          closeModal={closeModal}
          createAccount={createAccount}
          updateVerifiedUser={updateVerifiedUser}
        />
      </Choose.When>
      <Choose.When condition={currentModal === 'verifyUsername' && isIRCTCEducation===1}>
        <VerifyIrctcUserNameNew
          userStatus={{ userId }}
          showModal={true}
          switchModal={switchModal}
          allowClose={allowClose}
          closeModal={closeModal}
          createAccount={createAccount}
          updateVerifiedUser={updateVerifiedUser}
        />
      </Choose.When>
      <Choose.When condition={currentModal === 'usernameVerified'}>
        <UsernameVerified
          showModal={true}
          switchModal={switchModal}
          userStatus={{ userId }}
          updateVerifiedUser={updateVerifiedUser}
          allowClose={allowClose}
          closeModal={closeModal}
        />
      </Choose.When>
      <Choose.When condition={currentModal === 'userNotVerified'}>
        <UserNotVerified
          showModal
          switchModal={switchModal}
          userStatus={{ userId }}
          allowClose={allowClose}
          closeModal={closeModal}
        />
      </Choose.When>
      <Choose.When condition={currentModal === 'usernameDeactivated'}>
        <UsernameDeactivated
          showModal
          switchModal={switchModal}
          userStatus={{ userId }}
          allowClose={allowClose}
          closeModal={closeModal}
          createAccount={createAccount}
        />
      </Choose.When>
      <Choose.When condition={currentModal === 'forgotUsername'}>
        <ForgotUsername
          showModal={true}
          switchModal={switchModal}
          userStatus={{ userId }}
          allowClose={allowClose}
          closeModal={closeModal}
          createAccount={createAccount}
        />
      </Choose.When>
      <Choose.When condition={currentModal === 'failureWrongDetails'}>
        <FailureWrongDetails
          showModal={true}
          switchModal={switchModal}
          userStatus={{ userId }}
          allowClose={allowClose}
          closeModal={closeModal}
          createAccount={createAccount}
          updateVerifiedUser={updateVerifiedUser}
        />
      </Choose.When>
      <Choose.When condition={currentModal === 'getUsernameSuccess'}>
        <GetUsernameSuccess
          showModal={true}
          switchModal={switchModal}
          userStatus={{ userId }}
          allowClose={allowClose}
          closeModal={closeModal}
          createAccount={createAccount}
        />
      </Choose.When>
      <Choose.When condition={currentModal === 'forgotPassword'}>
        <ForgotPassword
          showModal
          switchModal={switchModal}
          userStatus={{ userId }}
          updateVerifiedUser={updateVerifiedUser}
          allowClose={allowClose}
          closeModal={closeModal}
          createAccount={createAccount}
          isStandAlone={false}
        />
      </Choose.When>
      <Choose.When condition={currentModal === 'getPasswordFailure'}>
        <GetPasswordFailure
          showModal
          switchModal={switchModal}
          userStatus={{ userId }}
          updateVerifiedUser={updateVerifiedUser}
          allowClose={allowClose}
          closeModal={closeModal}
          createAccount={createAccount}
        />
      </Choose.When>
      <Choose.When condition={currentModal === 'getPasswordFailureStandalone'}>
        <GetPasswordFailureStandAlone
          showModal
          switchModal={switchModal}
          userStatus={{ userId }}
          updateVerifiedUser={updateVerifiedUser}
          allowClose={true}
          closeModal={closeModal}
          createAccount={createAccount}
        />
      </Choose.When>
      <Choose.When condition={currentModal === 'getPasswordSuccess'}>
        <GetPasswordSuccess
          showModal
          switchModal={switchModal}
          userStatus={{ userId }}
          updateVerifiedUser={updateVerifiedUser}
          allowClose={allowClose}
          closeModal={closeModal}
          createAccount={createAccount}
        />
      </Choose.When>
      <Choose.When condition={currentModal === 'getPasswordSuccessStandalone'}>
        <GetPasswordSuccessStandalone
          showModal
          switchModal={switchModal}
          userStatus={userStatus}
          updateVerifiedUser={updateVerifiedUser}
          allowClose={true}
          closeModal={closeModal}
          createAccount={createAccount}
        />
      </Choose.When>
      <Choose.When condition={currentModal === 'emailAndMobileNotVerified'}>
        <EmailAndMobileNotVerified
          showModal
          switchModal={switchModal}
          userStatus={{ userId }}
          allowClose={allowClose}
          closeModal={closeModal}
          createAccount={createAccount}
          updateVerifiedUser={updateVerifiedUser}
          emailMobileNotVerified={true}
        />
      </Choose.When>
      <Choose.When condition={currentModal === 'mobileNotVerified'}>
        <MobileNotVerified
          showModal
          switchModal={switchModal}
          userStatus={{ userId }}
          allowClose={allowClose}
          closeModal={closeModal}
          createAccount={createAccount}
          isMobileNotVerified={true}
        />
      </Choose.When>
      <Choose.When condition={currentModal === 'emailNotVerified'}>
        <EmailNotVerified
          showModal
          switchModal={switchModal}
          userStatus={{ userId }}
          allowClose={allowClose}
          closeModal={closeModal}
          createAccount={createAccount}
          isEmailNotVerified={true}
        />
      </Choose.When>
      <Choose.When condition={currentModal === 'userProfileIncomplete'}>
        <UserProfileIncomplete
          showModal
          switchModal={switchModal}
          userStatus={{ userId }}
          allowClose={allowClose}
          closeModal={closeModal}
          createAccount={createAccount}
        />
      </Choose.When>
      <Choose.When condition={currentModal === 'userAccountSuspended'}>
        <UserAccountSuspended
          showModal
          switchModal={switchModal}
          userStatus={{ userId }}
          allowClose={allowClose}
          closeModal={closeModal}
          createAccount={createAccount}
        />
      </Choose.When>
      <Choose.When condition={currentModal === 'defaultCase'}>
        <DefaultCase
          showModal
          switchModal={switchModal}
          userStatus={{ userId }}
          allowClose={allowClose}
          closeModal={closeModal}
          createAccount={createAccount}
        />
      </Choose.When>
      <Choose.When condition={currentModal === 'forgotPasswordStandalone'}>
        {props.userStatus && <ForgotPasswordStandalone
          showModal
          switchModal={switchModal}
          userStatus={{ userId }}
          updateVerifiedUser={updateVerifiedUser}
          allowClose={allowClose}
          closeModal={closeModal}
          isStandAlone={true}
        />}
      </Choose.When>
    </Choose>
  );

};
